<template>
  <div class="content">
    <div class="user-profile">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
          <!-- <Card> -->
              <div>
            <ProfileForm :user="user" :company="company" @updateParent="updateParent" />
                <!-- <div class="row">
                  <div class="col-sm-6 col-md-5">
                    <button class="btn btn-primary btn-block" @click="updateUser">
                      <img src="static/img/loader.gif" v-if="isLoading" class="next-arrow">
                      <span v-else>Update profile</span>
                    </button>
                  </div>
                  <div class="col-sm-6 col-md-5">
                    <button class="btn btn-primary btn-block" data-toggle="modal" data-target="#myModal">
                      <span>Change Password</span>
                    </button>
                  </div>
                </div> -->
              </div>
              <!-- <div class="col-md-4">
                <user-card :user="user" @updateParent="updateParent"></user-card>
              </div> -->
          <!-- </Card> -->
        </div>

        <!--------------- MODAL STARTS -------------------->
        <!-- <div class="modal fade" id="myModal"> 
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Change password</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>

              <div class="modal-body">
                <form @submit="changePassword">
                  <div class="form-group">
                    <label for="current-password">Current Password</label>
                    <input
                      type="password"
                      id="current-password"
                      class="form-control"
                      placeholder="Enter current password"
                      v-model="currentPassword"
                    >
                  </div>
                  <div class="form-group">
                    <label for="new-password">New Password</label>
                    <input
                      type="password"
                      id="new-password"
                      class="form-control"
                      placeholder="Enter new password"
                      v-model="newPassword"
                    >
                  </div>
                  <div class="form-group">
                    <label for="new-password-2">Re-type New Password</label>
                    <input
                      type="password"
                      id="new-password-2"
                      class="form-control"
                      placeholder="Enter new password"
                      v-model="newPassword2"
                    >
                  </div>
                  <div class="row justify-content-center mt-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <button type="submit" class="btn btn-primary btn-block">
                          <img src="static/img/loader.gif" v-if="isChangingPassword" class="next-arrow">
                          <span v-else>Change</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div> -->
        <!--------------- MODAL ENDS -------------------->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProfileForm from "./UserProfile/ProfileForm.vue";
import UserCard from "./UserProfile/UserCard.vue";
import firebase from "../../../assets/config/firebase";
import Card from "src/components/UIComponents/Cards/Card.vue";
import sw from "sweetalert";

export default {
  components: {
    ProfileForm,
    UserCard,
    Card
  },
  data() {
    return {
      user: null,
      company: null,
      currentPassword: "",
      newPassword: "",
      newPassword2: "",
      isLoading: false,
      isChangingPassword: false,
      isImageChanged: false
    };
  },
  mounted() {
    const user = this.$store.state.auth.user;
    const company = this.$store.state.auth.company;

    if (user) {
      this.user = {
        ...user,
        nameToShow: user.username,
        aboutToShow: user.aboutMe,
        status: user.status || 'Active'
      };
      this.company = company;
    }
  },
  methods: {
    updateParent(e, isImageChanged) {
      const originalStatus = this.$store.state.auth.user.status || this.user.status || 'Active';
      this.user = {
        ...e,
        status: originalStatus // Preserve status
      };
      console.log('updateParent called, user:', this.user, 'isImageChanged:', isImageChanged);
      if (isImageChanged) {
        this.isImageChanged = true;
      }
    },
    async updateUser() {
      try {
        const newData = { ...this.user };
        delete newData.nameToShow;
        delete newData.aboutToShow;
        delete newData.status; // Prevent status update in Firebase
        console.log('updateUser newData:', newData);

        this.isLoading = true;
        if (this.isImageChanged) {
          const downloadURL = await firebase.uploadImage(
            "profileImages",
            this.user.profile_picture
          );

          newData.profile_picture = downloadURL;
        }

        const response = await firebase.updateDatabase(
          `users/${this.user.uid}`,
          newData
        );

        const updatedUser = {
          ...this.$store.state.auth.user,
          ...newData,
          status: this.$store.state.auth.user.status || this.user.status || 'Active' // Preserve status
        };

        console.log('Updating Vuex store with:', updatedUser);
        this.$store.commit("setUser", updatedUser);

        this.user.nameToShow = this.user.username;
        this.user.aboutToShow = this.user.aboutMe;
        this.isLoading = false;
        swal("Done", "Profile updated!", "success");
      } catch (e) {
        swal("Error!", e.message, "error");
        this.isLoading = false;
      }
    },
    async changePassword(e) {
      e.preventDefault();

      const user = this.$store.state.auth.user;
      const currentPassword = this.currentPassword;
      const newPassword = this.newPassword;
      const newPassword2 = this.newPassword2;

      try {
        if (newPassword !== newPassword2) {
          throw { message: "password's didn't matched" };
        }

        this.isChangingPassword = true;

        let response = await firebase.reAuthenticateUserFirebase({
          email: user.email,
          password: currentPassword
        });

        const promises = [
          firebase.updatePasswordFirebase(newPassword),
          firebase.updateDatabase(`/users/${user.uid}`, { firstLoggedIn: true })
        ];
        const updatedUser = { ...user, firstLoggedIn: true, status: user.status || 'Active' };
        this.$store.commit("setUser", updatedUser);
        console.log('changePassword, updated user:', updatedUser);
        this.clearPasswordFields();

        swal("Wooa!", "Your password is now upto date", "success");

        this.isChangingPassword = false;
      } catch (e) {
        this.clearPasswordFields();

        if (e.code === "auth/wrong-password") {
          e.message = "Current password is not correct";
        }

        this.isChangingPassword = false;

        swal("Oops!", e.message, "error");
      }

      this.closeModal();
    },
    clearPasswordFields() {
      this.currentPassword = "";
      this.newPassword = "";
      this.newPassword2 = "";
    },
    closeModal() {
      const modal = document.querySelector("#myModal");

      modal.click();
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UserProfile.vue